import { render, staticRenderFns } from "./TableWithDrawer.vue?vue&type=template&id=2cf159f5&scoped=true"
import script from "./TableWithDrawer.vue?vue&type=script&lang=js"
export * from "./TableWithDrawer.vue?vue&type=script&lang=js"
import style0 from "./TableWithDrawer.vue?vue&type=style&index=0&id=2cf159f5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf159f5",
  null
  
)

export default component.exports